import List from 'src/storage/list';
import adminModel from 'src/pages/admin/main/model';

class MoneyStatisticsModel extends List {
  id = 'MoneyStatisticsModel';
  defaultState = () => ({
    current: 'recent',
    pageIndex: 0,
    sortBy: {
      key: 'created',
      desc: true
    }
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  apiConfig = {
    refresh: {
      url: 'admin/doctor/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'admin/doctor/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'admin/doctor/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    }
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy,
      statusList: ['approved', 'enabled', 'disabled', 'active']
    };
    let startDate = this.input('from');
    if (startDate) {
      req.from = parseInt(startDate.startOf('day').valueOf());
    }
    let endDate = this.input('to');
    if (endDate) {
      req.to = parseInt(endDate.endOf('day').valueOf());
    }
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  handleChangeCurrency = () => {
    this.refresh();
  };

  getCurrency = () => {
    return adminModel.getCurrency();
  };
}

const model = new MoneyStatisticsModel();
export default model;
